(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["charms-upsell"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const containers = document.querySelectorAll('[data-lorecia-cu]');
    if (!containers.length) return;

    containers.forEach(initUpsell);

    function initUpsell(root) {
      const track = root.querySelector('[data-cu-track]');
      const cards = root.querySelectorAll('[data-cu-card]');
      const dots = root.querySelectorAll('[data-cu-dot]');
      const prevBtn = root.querySelector('[data-cu-prev]');
      const nextBtn = root.querySelector('[data-cu-next]');

      if (!track || !cards.length) return;

      // Carousel navigation
      if (prevBtn) prevBtn.addEventListener('click', () => scrollByOne(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => scrollByOne(1));

      function scrollByOne(direction) {
        const first = cards[0];
        const second = cards[1];
        const cardWidth = second
          ? second.getBoundingClientRect().left - first.getBoundingClientRect().left
          : first.getBoundingClientRect().width;
        track.scrollBy({ left: cardWidth * direction, behavior: 'smooth' });
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.cuDot, 10);
          const target = cards[index];
          if (target) {
            const offset = target.getBoundingClientRect().left
              - track.getBoundingClientRect().left
              + track.scrollLeft;
            track.scrollTo({ left: offset, behavior: 'smooth' });
          }
        });
      });

      const updateState = () => {
        const trackRect = track.getBoundingClientRect();
        let activeIndex = 0;
        let closestDistance = Infinity;

        cards.forEach((card, i) => {
          const distance = Math.abs(card.getBoundingClientRect().left - trackRect.left);
          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = i;
          }
        });

        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === activeIndex);
        });

        if (prevBtn) prevBtn.disabled = track.scrollLeft <= 1;
        if (nextBtn) nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      };

      let scrollTimer;
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(updateState, 80);
      });
      window.addEventListener('resize', updateState);
      updateState();

      // Quick-add to cart — fully isolated from the theme.
      // We use capture-phase + stopImmediatePropagation so no Dawn product-form
      // or theme handler ever sees this click. We never dispatch cart:* events
      // and never call drawer methods, because Dawn's product-form has a fallback
      // that does `window.location = routes.cart_url` when it can't find its
      // drawer — and we never want to risk triggering that path.
      const quickAddButtons = root.querySelectorAll('[data-quick-add]');
      quickAddButtons.forEach((btn) => {
        btn.addEventListener('click', async (e) => {
          // KILL the event for any other listener on the page
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') {
            e.stopImmediatePropagation();
          }

          if (btn.classList.contains('is-loading') || btn.classList.contains('is-success')) return;

          const variantId = btn.dataset.variantId;
          if (!variantId) return;

          btn.classList.add('is-loading');

          // --- Locate the cart drawer & its actual section IDs from the DOM ---
          function findDrawer() {
            return document.querySelector('cart-drawer') ||
                   document.querySelector('cart-notification') ||
                   document.querySelector('#CartDrawer') ||
                   document.querySelector('[data-cart-drawer]') ||
                   document.querySelector('.cart-drawer') ||
                   document.querySelector('.drawer--cart');
          }
          function sectionIdOf(el) {
            const wrapper = el && el.closest && el.closest('[id^="shopify-section-"]');
            return wrapper ? wrapper.id.replace('shopify-section-', '') : null;
          }

          const drawer = findDrawer();
          const drawerSectionId = sectionIdOf(drawer);

          // Find a header / cart-icon-bubble section so the count updates
          const bubbleEl =
            document.querySelector('cart-icon-bubble') ||
            document.querySelector('#cart-icon-bubble') ||
            document.querySelector('.header__icon--cart') ||
            document.querySelector('.cart-count-bubble');
          let headerSectionId = sectionIdOf(bubbleEl);
          if (!headerSectionId) {
            const headerWrapper =
              document.querySelector('[id^="shopify-section-"][id*="header" i]');
            if (headerWrapper) headerSectionId = headerWrapper.id.replace('shopify-section-', '');
          }

          const sectionList = [];
          if (drawerSectionId) sectionList.push(drawerSectionId);
          if (headerSectionId && headerSectionId !== drawerSectionId) sectionList.push(headerSectionId);

          try {
            // --- Add the item, requesting fresh section HTML in the response ---
            const formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', '1');
            if (sectionList.length) {
              formData.append('sections', sectionList.join(','));
              formData.append('sections_url', window.location.pathname);
            }

            const response = await fetch(`${window.Shopify.routes.root || '/'}cart/add.js`, {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: formData
            });

            const data = await response.json();
            if (!response.ok) {
              throw new Error(data.description || data.message || 'Add to cart failed');
            }

            btn.classList.remove('is-loading');
            btn.classList.add('is-success');

            // --- Swap section HTML directly. Bypass the theme entirely. ---
            if (data.sections) {
              Object.keys(data.sections).forEach((sectionId) => {
                const html = data.sections[sectionId];
                if (!html) return;
                const wrapper = document.getElementById('shopify-section-' + sectionId);
                if (wrapper) wrapper.innerHTML = html;
              });
            } else if (drawerSectionId) {
              // No sections in response (older themes) — refetch fresh
              try {
                const sectionRes = await fetch(`${window.Shopify.routes.root || '/'}?section_id=${encodeURIComponent(drawerSectionId)}`);
                if (sectionRes.ok) {
                  const html = await sectionRes.text();
                  const wrapper = document.getElementById('shopify-section-' + drawerSectionId);
                  if (wrapper) wrapper.innerHTML = html;
                }
              } catch (_) { /* noop */ }
            }

            // Open the drawer. We don't know which class/attribute this specific
            // theme uses, so we set every common one — but we *track exactly which
            // ones we added* (only the ones the drawer didn't already have) so we
            // can remove precisely those on close. We never touch classes the theme
            // manages itself.
            const refreshedDrawer = findDrawer();

            const OPEN_CLASS_CANDIDATES = [
              'is-open', 'active', 'drawer--is-open', 'js-drawer-open',
              'open', 'is-active', 'is-visible', 'cart-drawer--open',
              'drawer--active'
            ];
            const OVERLAY_CLASS_CANDIDATES = ['is-active', 'is-open', 'is-visible', 'active'];

            const drawerSnapshot = { classesAdded: [], hadAriaHidden: null, hadOpenAttr: false, hadHiddenAttr: false };
            if (refreshedDrawer) {
              drawerSnapshot.hadAriaHidden = refreshedDrawer.getAttribute('aria-hidden');
              drawerSnapshot.hadOpenAttr = refreshedDrawer.hasAttribute('open');
              drawerSnapshot.hadHiddenAttr = refreshedDrawer.hasAttribute('hidden');

              OPEN_CLASS_CANDIDATES.forEach((c) => {
                if (!refreshedDrawer.classList.contains(c)) {
                  refreshedDrawer.classList.add(c);
                  drawerSnapshot.classesAdded.push(c); // track only what we added
                }
              });
              if (!drawerSnapshot.hadOpenAttr) refreshedDrawer.setAttribute('open', '');
              refreshedDrawer.setAttribute('aria-hidden', 'false');
              refreshedDrawer.removeAttribute('hidden');
            }

            const overlay = document.querySelector(
              '.drawer-overlay, .drawer__overlay, .overlay, [data-drawer-overlay], .js-drawer-overlay'
            );
            const overlaySnapshot = { classesAdded: [], hadHiddenAttr: false };
            if (overlay) {
              overlaySnapshot.hadHiddenAttr = overlay.hasAttribute('hidden');
              OVERLAY_CLASS_CANDIDATES.forEach((c) => {
                if (!overlay.classList.contains(c)) {
                  overlay.classList.add(c);
                  overlaySnapshot.classesAdded.push(c);
                }
              });
              overlay.removeAttribute('hidden');
            }

            // --- Cleanup on close ---
            // We trigger cleanup in three ways:
            //   (a) clicks on common close-button / overlay selectors
            //   (b) Escape key
            //   (c) MutationObserver checking visual state as a backup
            // On cleanup we remove ONLY the classes/attributes we added (tracked
            // above), and we forcibly clear any scroll-lock state from <body>/<html>
            // that might be left behind.
            if (refreshedDrawer) {
              if (window.__loreciaCuTeardown) {
                try { window.__loreciaCuTeardown(); } catch (_) {}
              }

              let cleanedUp = false;
              const cleanup = () => {
                if (cleanedUp) return;
                cleanedUp = true;

                // Restore drawer state precisely
                drawerSnapshot.classesAdded.forEach((c) => refreshedDrawer.classList.remove(c));
                if (drawerSnapshot.hadAriaHidden === null) {
                  refreshedDrawer.removeAttribute('aria-hidden');
                } else {
                  refreshedDrawer.setAttribute('aria-hidden', drawerSnapshot.hadAriaHidden);
                }
                if (!drawerSnapshot.hadOpenAttr) refreshedDrawer.removeAttribute('open');
                if (drawerSnapshot.hadHiddenAttr) refreshedDrawer.setAttribute('hidden', '');

                // Restore overlay
                if (overlay) {
                  overlaySnapshot.classesAdded.forEach((c) => overlay.classList.remove(c));
                  if (overlaySnapshot.hadHiddenAttr) overlay.setAttribute('hidden', '');
                }

                // Aggressively scrub any scroll lock from <html> / <body>
                document.documentElement.classList.remove(
                  'drawer-is-open', 'js-drawer-open', 'overflow-hidden', 'no-scroll', 'scroll-lock'
                );
                document.body.classList.remove(
                  'drawer-is-open', 'js-drawer-open', 'cart-drawer-open',
                  'overflow-hidden', 'no-scroll', 'scroll-lock', 'modal-open',
                  'has-drawer-open', 'is-locked'
                );
                if (document.body.style.overflow === 'hidden') document.body.style.overflow = '';
                if (document.body.style.position === 'fixed') document.body.style.position = '';
                if (document.documentElement.style.overflow === 'hidden') document.documentElement.style.overflow = '';

                // Tear down listeners
                document.removeEventListener('click', onCloseClick, true);
                document.removeEventListener('keydown', onEscape, true);
                if (visObserver) visObserver.disconnect();
                window.__loreciaCuTeardown = null;
              };

              const onCloseClick = (ev) => {
                const closeTarget = ev.target.closest(
                  '.drawer__close, .drawer-close, [data-drawer-close], ' +
                  '.cart-drawer__close, .js-drawer-close, ' +
                  'button[aria-label*="close" i], button.close, ' +
                  '.drawer-overlay, .drawer__overlay, .overlay, ' +
                  '[data-drawer-overlay], .js-drawer-overlay'
                );
                if (closeTarget) {
                  setTimeout(cleanup, 400); // wait for the theme's close animation
                }
              };
              const onEscape = (ev) => {
                if (ev.key === 'Escape') setTimeout(cleanup, 400);
              };

              const isVisuallyOpen = (el) => {
                if (!el || !document.body.contains(el)) return false;
                if (el.getAttribute('aria-hidden') === 'true') return false;
                const style = window.getComputedStyle(el);
                if (style.display === 'none') return false;
                if (style.visibility === 'hidden') return false;
                if (parseFloat(style.opacity) < 0.05) return false;
                const rect = el.getBoundingClientRect();
                if (rect.width < 5 || rect.height < 5) return false;
                if (rect.right <= 0 || rect.left >= window.innerWidth) return false;
                return true;
              };

              let visObserver = null;
              // Start visibility-watching after the open animation has begun
              setTimeout(() => {
                visObserver = new MutationObserver(() => {
                  if (!isVisuallyOpen(refreshedDrawer)) cleanup();
                });
                visObserver.observe(refreshedDrawer, {
                  attributes: true,
                  attributeFilter: ['class', 'style', 'aria-hidden', 'hidden', 'open']
                });
              }, 500);

              document.addEventListener('click', onCloseClick, true);
              document.addEventListener('keydown', onEscape, true);
              window.__loreciaCuTeardown = cleanup;
            }

            setTimeout(() => btn.classList.remove('is-success'), 1800);

          } catch (err) {
            console.error('[lorecia-cu]', err);
            btn.classList.remove('is-loading');
          }
        }, true); // <-- capture phase
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const containers = document.querySelectorAll('[data-lorecia-faq]');
    if (!containers.length) return;

    containers.forEach(initFaq);

    function initFaq(root) {
      if (root.dataset.faqInit === 'true') return;
      root.dataset.faqInit = 'true';

      const behavior = root.dataset.behavior || 'multi';
      const items = root.querySelectorAll('[data-faq-item]');

      items.forEach((item) => {
        const trigger = item.querySelector('[data-faq-trigger]');
        const panel = item.querySelector('[data-faq-panel]');
        if (!trigger || !panel) return;

        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          const isOpen = trigger.getAttribute('aria-expanded') === 'true';

          // In single-open mode, close all others first
          if (behavior === 'single') {
            items.forEach((other) => {
              if (other === item) return;
              const otherTrigger = other.querySelector('[data-faq-trigger]');
              const otherPanel = other.querySelector('[data-faq-panel]');
              if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
              if (otherPanel) otherPanel.setAttribute('hidden', '');
            });
          }

          if (isOpen) {
            trigger.setAttribute('aria-expanded', 'false');
            panel.setAttribute('hidden', '');
          } else {
            trigger.setAttribute('aria-expanded', 'true');
            panel.removeAttribute('hidden');
          }
        });
      });
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-lorecia-faq]');
      if (root) {
        root.dataset.faqInit = '';
        initFaq(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const containers = document.querySelectorAll('[data-lorecia-rec]');
    if (!containers.length) return;

    containers.forEach(initRecommendations);

    function initRecommendations(root) {
      const source = root.dataset.source;
      if (source === 'smart' && root.dataset.productId) {
        loadSmartRecommendations(root).then(() => initCarousel(root));
      } else {
        initCarousel(root);
      }
    }

    async function loadSmartRecommendations(root) {
      const productId = root.dataset.productId;
      const sectionId = root.dataset.sectionId;
      const intent = root.dataset.intent || 'related';
      const limit = root.dataset.limit || '8';
      const url = root.dataset.url || '/recommendations/products';

      if (!productId || !sectionId) return;

      root.classList.add('is-loading');

      try {
        const params = new URLSearchParams({
          section_id: sectionId,
          product_id: productId,
          limit: limit,
          intent: intent
        });

        const response = await fetch(`${url}?${params.toString()}`);
        if (!response.ok) throw new Error('Recommendations fetch failed');
        const html = await response.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newTrack = doc.querySelector('[data-rec-track]');
        const currentTrack = root.querySelector('[data-rec-track]');

        if (newTrack && currentTrack && newTrack.children.length > 0) {
          currentTrack.innerHTML = newTrack.innerHTML;
        }
      } catch (err) {
        console.warn('[lorecia-rec] using server-rendered fallback:', err);
      } finally {
        root.classList.remove('is-loading');
      }
    }

    function initCarousel(root) {
      const track = root.querySelector('[data-rec-track]');
      const cards = track ? track.querySelectorAll('[data-rec-card]') : [];
      const dotsContainer = root.querySelector('[data-rec-dots]');
      const prevBtn = root.querySelector('[data-rec-prev]');
      const nextBtn = root.querySelector('[data-rec-next]');

      if (!track || !cards.length) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        return;
      }

      if (dotsContainer && cards.length > 1) {
        dotsContainer.innerHTML = '';
        cards.forEach((_, i) => {
          const dot = document.createElement('button');
          dot.className = 'lorecia-rec__dot' + (i === 0 ? ' is-active' : '');
          dot.type = 'button';
          dot.setAttribute('aria-label', `Go to product ${i + 1}`);
          dot.dataset.recDot = String(i);
          dot.addEventListener('click', () => {
            const target = cards[i];
            if (target) {
              const offset = target.getBoundingClientRect().left
                - track.getBoundingClientRect().left
                + track.scrollLeft;
              track.scrollTo({ left: offset, behavior: 'smooth' });
            }
          });
          dotsContainer.appendChild(dot);
        });
      }

      const dots = dotsContainer ? dotsContainer.querySelectorAll('[data-rec-dot]') : [];

      if (prevBtn) prevBtn.addEventListener('click', () => scrollByOne(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => scrollByOne(1));

      function scrollByOne(direction) {
        const first = cards[0];
        const second = cards[1];
        const cardWidth = second
          ? second.getBoundingClientRect().left - first.getBoundingClientRect().left
          : first.getBoundingClientRect().width;
        track.scrollBy({ left: cardWidth * direction, behavior: 'smooth' });
      }

      const updateState = () => {
        const trackRect = track.getBoundingClientRect();
        let activeIndex = 0;
        let closestDistance = Infinity;

        cards.forEach((card, i) => {
          const distance = Math.abs(card.getBoundingClientRect().left - trackRect.left);
          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = i;
          }
        });

        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === activeIndex);
        });

        if (prevBtn) prevBtn.disabled = track.scrollLeft <= 1;
        if (nextBtn) nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      };

      let scrollTimer;
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(updateState, 80);
      });
      window.addEventListener('resize', updateState);
      updateState();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lorecia-video-carousel')) {
    customElements.define(
      'lorecia-video-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-vc-track]');
          this.slides = Array.from(this.querySelectorAll('[data-vc-slide]'));
          if (!this.track || !this.slides.length) return;

          this.dotsWrap = this.querySelector('[data-vc-dots]');
          this.dots = Array.from(this.querySelectorAll('[data-vc-dot]'));
          this.prevBtn = this.querySelector('[data-vc-prev]');
          this.nextBtn = this.querySelector('[data-vc-next]');
          this.videos = Array.from(this.querySelectorAll('[data-vc-video]'));

          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.autoplay = this.dataset.autoplay === 'true' && !this.reducedMotion;

          this.setupVideos();
          this.setupNav();
          this.setupObserver();
          this.setupEditor();
          this.updateUI();
        }

        disconnectedCallback() {
          if (this.io) this.io.disconnect();
          if (this.ro) this.ro.disconnect();
          clearTimeout(this.scrollTimer);
          if (this.onBlockSelect) {
            document.removeEventListener('shopify:block:select', this.onBlockSelect);
          }
        }

        stride() {
          return this.slides[1]
            ? this.slides[1].offsetLeft - this.slides[0].offsetLeft
            : this.slides[0].offsetWidth || 1;
        }

        goTo(index) {
          const i = Math.max(0, Math.min(index, this.slides.length - 1));
          this.track.scrollTo({
            left: this.slides[i].offsetLeft - this.slides[0].offsetLeft,
            behavior: this.reducedMotion ? 'auto' : 'smooth'
          });
        }

        step(dir) {
          const current = Math.round(this.track.scrollLeft / this.stride());
          this.goTo(current + dir);
        }

        updateUI() {
          const maxScroll = this.track.scrollWidth - this.track.clientWidth;
          const active = Math.max(
            0,
            Math.min(Math.round(this.track.scrollLeft / this.stride()), this.slides.length - 1)
          );

          this.dots.forEach((dot, i) => {
            dot.classList.toggle('is-active', i === active);
            if (i === active) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });

          if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 1;
          if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= maxScroll - 1;
          if (this.dotsWrap) this.dotsWrap.hidden = maxScroll <= 1;
        }

        setupNav() {
          if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
          if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));

          this.dots.forEach((dot, i) => {
            dot.addEventListener('click', () => this.goTo(i));
          });

          this.track.addEventListener(
            'scroll',
            () => {
              clearTimeout(this.scrollTimer);
              this.scrollTimer = setTimeout(() => this.updateUI(), 60);
            },
            { passive: true }
          );

          if ('ResizeObserver' in window) {
            this.ro = new ResizeObserver(() => this.updateUI());
            this.ro.observe(this.track);
          }
        }

        setupVideos() {
          // Force-mute every video and keep it muted no matter what
          this.videos.forEach((video) => {
            video.muted = true;
            video.setAttribute('muted', '');
            video.removeAttribute('controls');
            video.addEventListener('volumechange', () => {
              if (!video.muted) video.muted = true;
            });
          });

          // Per-slide play/pause (only if the button is rendered)
          this.slides.forEach((slide) => {
            const video = slide.querySelector('[data-vc-video]');
            const btn = slide.querySelector('[data-vc-playpause]');
            if (!video || !btn) return;

            btn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              video.muted = true;
              if (video.paused) {
                delete slide.dataset.userPaused;
                video.play().catch(() => {});
                slide.classList.add('is-playing');
                slide.classList.remove('is-paused');
              } else {
                slide.dataset.userPaused = 'true';
                video.pause();
                slide.classList.remove('is-playing');
                slide.classList.add('is-paused');
              }
            });
          });
        }

        setupObserver() {
          if (!this.videos.length || !('IntersectionObserver' in window)) return;

          this.io = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const video = entry.target;
                const slide = video.closest('[data-vc-slide]');
                video.muted = true;

                if (
                  entry.isIntersecting &&
                  this.autoplay &&
                  (!slide || slide.dataset.userPaused !== 'true')
                ) {
                  video
                    .play()
                    .then(() => {
                      if (slide) slide.classList.add('is-playing');
                    })
                    .catch(() => {});
                } else if (!entry.isIntersecting) {
                  video.pause();
                  if (slide) slide.classList.remove('is-playing');
                }
              });
            },
            { threshold: 0.4 }
          );

          this.videos.forEach((v) => this.io.observe(v));
        }

        setupEditor() {
          if (!window.Shopify || !window.Shopify.designMode) return;
          this.onBlockSelect = (e) => {
            const i = this.slides.indexOf(e.target);
            if (i > -1) this.goTo(i);
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
